module.exports = __webpack_public_path__ + "static/media/icono_historial_blanco.f8013066.svg";